import React, { PureComponent } from 'react';
import { arrayOf, func, string, object } from 'prop-types';
import classNames from 'classnames';
import { withRouter } from 'react-router-dom';

import Link from './WrappedLink';

class Tabs extends PureComponent {
  static propTypes = {
    section: string,
    id: string,
    nome: string,
    route: string,
    tabs: arrayOf(string),
    getTabUrl: func,
    role: arrayOf(string),
    location: object,
  };

  constructor(props) {
    super(props);
    this.state = {
      index: '',
      visibleSelectedItem: true,
    };
  }

  render() {
    const { tabs, section, location } = this.props;

    const handleTabUrl = (tab, i) => {
      this.props.getTabUrl(tab);
      this.setState({
        index: i,
        visibleSelectedItem: false,
      });
    };

    return (
      <div className="tabs is-boxed">
        <ul>
          {tabs.map((tab, i) => {
            const isSelected = (!i && section === null) || section === tab.toLowerCase();

            const { index, visibleSelectedItem } = this.state;

            const onSelectedItem = classNames({
              'is-active': isSelected,
            });
            return (
              <li
                key={tab}
                onClick={() => handleTabUrl(tab, i)}
                className={visibleSelectedItem ? (onSelectedItem) : (i === index ? 'is-active' : null)}
              >
                <Link to={`${location.pathname}?section=${tab.toLowerCase()}`}>
                  <span>{tab}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}

Tabs.displayName = 'Tabs';

export default withRouter(Tabs);
